export const TYPE_CORRECTION = {
    LINE: 'LINE',
    WORD: 'WORD',
}

export const DICTADO_SOUNDS = {
    DRAG: "drag",
    GOOD_ACTIVE: "goodActive",
    LOW_WRITE: "lowWrite",
    LOW_WRONG: "lowWrong",
    MOVE: "move",
    ACTIVE: "activeButton",
    PLACE: "place",
}